export function getPath(state) {
	var fullPath = "/student_lists";

	if (state.orgIdentifier) {
		fullPath += "/" + state.orgIdentifier;
	} else {
		fullPath += "/" + DEFAULT_ORG_IDENTIFIER_KEY;
	}

	if (state.activeView) {
		fullPath += "/" + state.activeView;
	} else {
		fullPath += "/" + VIEWS.SHELF_VIEW;
	}

	if (state.detailsView) {
		fullPath += "/" + state.detailsView;
		if (state.textID) {
			fullPath += "/" + state.textID;
		}
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	state.orgIdentifier = params.org_identifier;
	state.activeView = params.active_view;
	state.detailsView = params.details_view;
	state.textID = params.text_id;
	
	return state;
}

export const DEFAULT_ORG_IDENTIFIER_KEY = "default";

export const VIEWS = {
	TREE_VIEW: "tree",
	SHELF_VIEW: "shelf",
	PHOTO_VIEW: "photos"
}

export const PATH = "/student_lists/:org_identifier/:active_view/:details_view?/:text_id?";


// WEBPACK FOOTER //
// ./modules/lib/routing/ClassPageRouting.js